"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TextRephraseIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M13.984 13.809a.675.675 0 010 1.35H2.016a.675.675 0 010-1.35h11.968zm0-2.351a.675.675 0 110 1.35H2.016a.675.675 0 010-1.35h11.968zm0-2.351a.675.675 0 110 1.351H9.016a.675.675 0 010-1.35h4.968z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.553 1.86a.928.928 0 00-1.307-.113l-.47.393 1.791 2.13.469-.393a.928.928 0 00.113-1.307l-.596-.71zm-2.256.684l1.79 2.13L6.27 9.561l-2.296.91a.643.643 0 01-.786-.935L4.48 7.431l5.818-4.887z"
  })))
});
TextRephraseIcon.displayName = 'TextRephraseIcon';
var _default = exports.default = TextRephraseIcon;